export const sgrColor = {
  'sgr-grey': '#F1F1F1',
  '50': '#c5cff5',
  '100': '#aeb7da',
  '200': '#979fc0',
  '300': '#8087a5',
  '400': '#696f8a',
  '500': '#52576f',
  '600': '#3b3f55',
  '700': '#24273a',
  '800': '#1f2232',
  '900': '#181926',
};

// These are the new colors
export const sgrColors = {
  blue: '#1E3E8C',
  grey_cloud: '#D3DDE5',
  rose: '#DD1817',
  light_red: '#f7dede',
  warning: '#dd7d17',
  success: '#28a745',
  navy: '#00519D',
  mine_shaft: '#040405',
  breadcrumb_bold: '#242424',
  azure: '#008AD0',
  steel: '#B7BFCD',
  sky_blue: '#00A5E4',
  frost_grey: '#FBFCFE',
  hover_sky_blue: '#d3dde5', // 80% opacity,
  disabled: '#eeeeee',
  backdrop: '#7f7f7f',
  chips_background: '#eef7fb',
};
